module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#environment",
      toString: function () {
        return this.url;
      }
    }